import { createFileRoute } from "@tanstack/react-router"
import BackofficeGmailReader from "modules/backoffice/components/gmailReader"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/gmailReader")({
  component: BackofficeGmailReader,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.gmailReader.title"),
    })
  },
})
